export function pxToRem(value: string | number) {
    if (typeof value === 'number') {
        return `${value / 16}rem`;
    }
    return value;
}
